import { call, put, takeEvery } from "redux-saga/effects"

import { GET_TITLES, ADD_NEW_TITLE, UPDATE_TITLE, DELETE_TITLE } from "./actionTypes";
import {
    getTitlesSuccess,
    getTitlesFail,
    addTitleSuccess,
    addTitleFail,
    updateTitleSuccess,
    updateTitleFail,
    deleteTitleSuccess,
    deleteTitleFail,
   
} from "./actions"

import {
    getTitles,
    addNewTitle,
    updateTitle,
    deleteTitle,
   
} from "helpers/titles/titles_backend_helper";
import { toast } from "react-toastify";

function* fetchTitles() {
    try {
        const response = yield call(getTitles)
        console.log("RESPONSE:", response);
        yield put(getTitlesSuccess(response))
    } catch (error) {
        yield put(getTitlesFail(error))
    }
}

function* onAddNewTitle({ payload }) {
    try {

        
        const response = yield call(addNewTitle, payload)

        console.log("RESPONSE:", response);
        yield put(addTitleSuccess(response.title))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        console.log("ERROR:", error);
        yield put(addTitleFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}

/*
function* onUpdateTitle({ payload: data }) {
    try {
        const response = yield call(updateTitle, data)
        yield put(updateTitleSuccess(response))
        toast.success("Branch  Updated Successfully", { autoClose: 2000 });
    } catch (error) {
        yield put(updateTitleFail(error))
        toast.error("Branch  Updated Failed", { autoClose: 2000 });
    }
}
    */

function* onUpdateTitle({ payload}) {
    try {
        console.log("UPDATE: ", payload);
        const response = yield call(updateTitle, payload)
        yield put(updateTitleSuccess(response.title))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        yield put(updateTitleFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}

function* onDeleteTitle({ payload}) {

    try {
        const response = yield call(deleteTitle, payload)
        yield put(deleteTitleSuccess(response.titleId))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        yield put(deleteTitleFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}


function* titleSaga() {
    yield takeEvery(GET_TITLES, fetchTitles)
    yield takeEvery(ADD_NEW_TITLE, onAddNewTitle)
    yield takeEvery(UPDATE_TITLE, onUpdateTitle)
    yield takeEvery(DELETE_TITLE, onDeleteTitle)
}

export default titleSaga;